import Image from 'app/Components/Shared/Image/image';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import PageEnum from 'app/Components/Block/LocalCellularTroubleshootingWizardBlock/constant/PageEnum';
import { buildUrlAndOpenSameWindow } from '../../../../../utilities/StringHelpers/StringHelpers';
import BtnWhiteBlackBorderBigSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderBigSize';
import Config from '../../../../../Config';
import successIcon from '../../images/success-icon.svg';

const SuccessPage = (props) => {


    function handleOnClickButton(){
        buildUrlAndOpenSameWindow(props.epiBlockData.finalButtonLink);
    }


    return (
        <div className="success-page">
            <div className='content'>
                <div className='img-error'>
                    <Image src={successIcon} alt='error-icon' />
                </div>
                <div className='title'>מעולה, שמחנו לעזור!</div>
            </div>
            <div className='button-wrapper'>
                   <BtnWhiteBlackBorderBigSize
                        text={props.epiBlockData.finalButtonText}
                        onclick={() => {
                            handleOnClickButton();
                        }}
                    />
            </div>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        pageContent: state.localCellularTroubleshootingWizardBlock.pageContent,
        epiBlockData: state.localCellularTroubleshootingWizardBlock.epiBlockData
    };
};

const mapDispatchToProps = { };

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
